
const initPaginate = () => {
  return {
    from: 1,
    to: 9,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    total: 0,
  }
}

/** state **/
const state = {
  vesselPagination: initPaginate(),
  crewPagination: initPaginate(),
  userPagination: initPaginate(),
  cmsUserPagination: initPaginate(),
  objCrewKeysPagination : initPaginate()
};

/** mutations **/
const mutations = {
  set_vessel_paginated(state,payload) {
    state.vesselPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    }
  },

  set_user_pagination(state,payload) {
    state.userPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    }
  },

  set_cms_user_pagination(state,payload) {
    state.cmsUserPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    }
  },

  set_crew_pagination(state,payload){
    state.crewPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    }
  },

  //objCrewKeysPagination
  set_obj_crew_keys_pagination(state,payload) {
    // console.log('Test 123',payload);
    state.objCrewKeysPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    }
  },

  reset_vessel_pagination(state) {
    Object.assign(state.vesselPagination,initPaginate());
  },

  reset_crew_pagination(state){
    Object.assign(state.crewPagination,initPaginate())
  },

  reset_user_pagination(state){
    Object.assign(state.userPagination,initPaginate())
  },

  reset_cms_user_pagination(state,payload){
    Object.assign(state.cmsUserPagination,initPaginate())
  },

  reset_obj_crew_keys_pagination(state){
    Object.assign(state.objCrewKeysPagination,initPaginate())
  }

};

/** actions **/
const actions = {

  resetVesselPagination({commit}){
    commit('reset_vessel_pagination')
  },

  resetObjCrewKeysPagination({commit}){
    // console.log('canceling crew key pagination')
    commit('reset_obj_crew_keys_pagination');
  }
};

/** getters **/
const getters = {
  vesselPagination : state => state.vesselPagination,
  userPagination : state => state.userPagination,
  cmsUserPagination : state => state.cmsUserPagination,
  objCrewKeysPagination : state => state.objCrewKeysPagination
};

/** export **/
export default {state, actions, mutations, getters};
